import {
  SET_CATALOG_STATUS,
  SET_CATALOG,
  SET_VAULT_STATUS,
  SET_RELIC_VAULT_STATE,
  SET_OWNED_RELICS,
  SET_GUARDIAN_STATE,
  SET_STORE_SLOTS,
  RESET_RELIC_VAULT,
} from './actionTypes';

export const NO_GUARDIAN = 'none';

// One state for the Collection Store, all of it from the backend.
//
// The catalog (guilds, guardians, relics, badges) is the same for every learner
// and is fetched once per session. Ownership and the store slots belong to the
// learner and are re-read whenever the server changes them - every purchase,
// sale and refresh returns the new truth, so nothing is guessed locally.
const initialState = {
  // 'idle' | 'loading' | 'ready' | 'error'
  catalogStatus: 'idle',
  catalogError: null,
  guilds: [],
  guardians: [],
  relics: [],
  rarities: [],
  sheetGrid: null,
  badgeCategories: [],

  vaultStatus: 'idle',
  vaultError: null,
  hydrated: false,

  ownedRelicIds: [],
  // Guardian ownership is keyed by guildId ("quik"), not guardian id.
  ownedCompanionIds: [],
  // Badge ids ("EXP-001") the learner has earned. Awarded by the server for
  // meeting a badge's requirement, never bought.
  ownedBadgeIds: [],
  equippedCompanionId: NO_GUARDIAN,
  // The id Unity's set_guardian command takes for the equipped guardian.
  equippedUnityGuardianId: NO_GUARDIAN,

  // The five relics on offer, and today's refresh allowance. All server-owned:
  // which relics appear is the backend's rotation, not a local shuffle.
  storeRelicIds: [],
  refreshesUsed: 0,
  refreshesLeft: 0,
  nextRefreshCost: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CATALOG_STATUS:
      return {
        ...state,
        catalogStatus: action.payload.status,
        catalogError: action.payload.error ?? null,
      };
    case SET_CATALOG:
      return {
        ...state,
        guilds: action.payload.guilds || [],
        guardians: action.payload.guardians || [],
        relics: action.payload.relics?.relics || [],
        rarities: action.payload.relics?.rarities || [],
        sheetGrid: action.payload.relics?.sheetGrid || null,
        badgeCategories: action.payload.badgeCategories || [],
        catalogStatus: 'ready',
        catalogError: null,
      };
    case SET_VAULT_STATUS:
      return {
        ...state,
        vaultStatus: action.payload.status,
        vaultError: action.payload.error ?? null,
      };
    case SET_RELIC_VAULT_STATE:
      return { ...state, ...action.payload, hydrated: true, vaultStatus: 'ready' };
    case SET_OWNED_RELICS:
      return { ...state, ownedRelicIds: action.payload || [] };
    case SET_GUARDIAN_STATE:
      return {
        ...state,
        ownedCompanionIds: action.payload.ownedGuildIds || state.ownedCompanionIds,
        equippedCompanionId: action.payload.equippedGuildId || NO_GUARDIAN,
        equippedUnityGuardianId:
          action.payload.equippedUnityGuardianId || NO_GUARDIAN,
      };
    case SET_STORE_SLOTS:
      return {
        ...state,
        storeRelicIds: action.payload.slotRelicIds || [],
        refreshesUsed: action.payload.refreshesUsed ?? state.refreshesUsed,
        refreshesLeft: action.payload.refreshesLeft ?? state.refreshesLeft,
        nextRefreshCost: action.payload.nextRefreshCost ?? null,
      };
    case RESET_RELIC_VAULT:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;
